import { defineMessages } from 'react-intl'

export default defineMessages({
  listHeader: {
    id: 'catalogPermissionUserConfigTable.listHeader',
    defaultMessage: 'Users',
  },
  searchPlaceholder: {
    id: 'catalogPermissionUserConfigTable.searchPlaceholder',
    defaultMessage: 'Search by username',
  },
  searchAriaLabel: {
    id: 'catalogPermissionUserConfigTable.searchAriaLabel',
    defaultMessage: 'Search by username',
  },
  searchButtonAriaLabel: {
    id: 'catalogPermissionUserConfigTable.searchButtonAriaLabel',
    defaultMessage: 'Search',
  },
  emptyState: {
    id: 'catalogPermissionUserConfigTable.emptyState',
    defaultMessage: 'No users found',
  },
  errorState: {
    id: 'catalogPermissionUserConfigTable.errorState',
    defaultMessage: 'Unable to load users. Please try again.',
  },
})
